import * as amplitude from "@amplitude/analytics-browser";
import { config } from "./config";
const amplitudeConfig = {
    eventUploadPeriodMillis: 3000,
    includeReferrer: true,
    includeUtm: true,
    includeGclid: true,
    includeFbclid: true,
    serverUrl: "https://scope2.gather.town/2/httpapi",
};
amplitude.init(config.amplitudeAPIKey, undefined, amplitudeConfig);
export default amplitude;
//# sourceMappingURL=amplitude.js.map